/**
 * Normalizes a URL by ensuring it has a proper protocol.
 * If the URL doesn't have a protocol, it defaults to https://.
 *
 * @param url - The URL to normalize
 * @returns The normalized URL with a proper protocol
 */
export function normalizeUrl(url: string): string {
  if (!url || typeof url !== 'string') {
    return url;
  }

  const trimmedUrl = url.trim();

  // If the trimmed URL is empty, return empty string
  if (trimmedUrl === '') {
    return '';
  }

  // If the URL already has a protocol, return it as is
  if (/^https?:\/\//i.test(trimmedUrl)) {
    return trimmedUrl;
  }

  // If it starts with //, it's a protocol-relative URL, add https:
  if (trimmedUrl.startsWith('//')) {
    return `https:${trimmedUrl}`;
  }

  // Otherwise, assume it's a domain and add https://
  return `https://${trimmedUrl}`;
}
